<template>
  <router-view />
  <ToastifyContainer />
</template>

<script>
import { ToastifyContainer } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

export default {
  name: 'App',
  components: {
    ToastifyContainer,
  },
  created() {
    this.$store.dispatch('auth/initAuth')
  },
  beforeUnmount() {
    this.$store.dispatch('auth/stopSessionWatch')
  },
}
</script>

<style lang="scss"></style>
